import React from "react";

import Container from "react-bootstrap/Container";
import { useHistory, useLocation } from "react-router-dom";

import {
  getUserManual as getUserManualApi,
  getTermsOfService as getTermsOfServiceApi,
} from "../../api/kindergartenApi";
import {
  aboutProgramRoute,
  dashboard as dashboardRoute,
} from "../../routes/routes";
import { izjavaOPristupacnostiRoute } from "../../routes/routes";
import { CustomFooter, FooterItem } from "../CustomFooter";
import { Navbar } from "../Navbar/Navbar";
import styles from "./Layout.module.scss";
import Navigation from "./Navigation";

interface Props {
  setImpairedStyle: () => void;
  removeImpairedStyle: () => void;
  children?: React.ReactNode;
}

export default function Layout({
  children,
  setImpairedStyle,
  removeImpairedStyle,
}: Props) {
  const { pathname } = useLocation();
  const history = useHistory();

  const resolveMainRouteStyle = (): string => {
    if (pathname === dashboardRoute()) {
      return styles.mainGrey;
    }
    return styles.mainWhite;
  };

  const showAboutProgram = () => {
    window.scrollTo(0, 0);
    history.push(aboutProgramRoute());
  };
  const showIzjavaOPristupacnosti = () => {
    window.scrollTo(0, 0);
    history.push(izjavaOPristupacnostiRoute());
  };

  const footerItems: Array<FooterItem> = [
    {
      label: "Uvjeti korištenja",
      callback: (item: FooterItem) => {
        getTermsOfServiceApi();
        return false;
      },
    },
    {
      label: "Korisničke upute",
      callback: (item: FooterItem) => {
        getUserManualApi();
        return false;
      },
    },
    {
      label: "O programu",
      callback: (item: FooterItem) => {
        showAboutProgram();
        return false;
      },
    },
    {
      label: "Izjava o pristupačnosti",
      callback: (item: FooterItem) => {
        showIzjavaOPristupacnosti();
        return false;
      },
    },
  ];

  const mainClassName = [styles.main, resolveMainRouteStyle()].join(" ");

  return (
    <>
      <Navbar
        setImpairedStyle={setImpairedStyle}
        removeImpairedStyle={removeImpairedStyle}
      />
      <Navigation />
      <main className={`${mainClassName}`}>
        <Container className={styles.container}>{children}</Container>
      </main>
      <CustomFooter items={footerItems} />
    </>
  );
}
